import { ClickAwayListener } from '@mui/material';
import React, { useMemo, useRef, useState } from 'react';
import { IconType } from '../../../../ui/icons/Icon';
import IconButton from '../../../../ui/icons/IconButton';
import MenuItem, { MenuItemProps } from './MenuItem';

interface MenuProps {
  items: MenuItemProps[];
}

export default function Menu({ items }: MenuProps) {
  const button = useRef<HTMLDivElement>(null);
  const menu = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen(!open);
  };

  const closeMenu = () => {
    setOpen(false);
  };

  const position = useMemo(() => {
    if (!button.current || !menu.current) return 'left-0 ml-0.5';

    const buttonRect = button.current.getBoundingClientRect();
    const menuRect = menu.current.getBoundingClientRect();

    const spaceRight = window.innerWidth - buttonRect.right;
    const spaceLeft = buttonRect.left;

    if (spaceRight >= menuRect.width) {
      return 'left-0 ml-0.5';
    } else if (spaceLeft >= menuRect.width) {
      return 'right-0 mr-0.5';
    } else {
      return 'left-0 ml-0.5';
    }
  }, [open, button, menu]);

  if (!items.length) return null;

  return (
    <ClickAwayListener onClickAway={closeMenu}>
      <div
        className={`relative flex h-10 w-10 cursor-pointer select-none items-center justify-center bg-white`}
        ref={button}
        data-testid={'menu'}
      >
        <IconButton type={IconType.dotsVertical} onClick={toggleMenu} />

        <div
          ref={menu}
          className={`absolute ${position} top-0 z-10 mt-11 min-w-[200px] rounded-2 bg-white p-2 shadow-default`}
          style={{
            visibility: open ? 'visible' : 'hidden',
          }}
        >
          {items.map(item => (
            <MenuItem {...item} key={item.text} />
          ))}
        </div>
      </div>
    </ClickAwayListener>
  );
}
